import React from "react"
import { useTranslation } from "react-i18next"
import {
  Button,
  IconButton,
  SvgIcon
} from "@mui/material"
import { ReactComponent as OpenInEditorIcon } from "../icons/icon_edit.svg"
import { postEditorOpened } from "src/services/api/metrics"
import { useResponsive } from "src/utils/useResponsive"

interface Props {
  assignmentId: string
  iconOnly?: boolean
  onOpenEmailModal?: () => void
}

const OpenInEditorButton = ({ assignmentId, iconOnly, onOpenEmailModal }: Props) => {
  const { t } = useTranslation("common")
  const { isMobile } = useResponsive()

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent event bubbling
    postEditorOpened()
    if (isMobile && onOpenEmailModal) {
      onOpenEmailModal()
    }
  }

  if (iconOnly) {
    return (
      <IconButton onClick={onClick} color="primary" sx={{ p: 1 }}>
        <SvgIcon component={OpenInEditorIcon} inheritViewBox style={{ fontSize: "1.125rem" }} />
      </IconButton>
    )
  }

  if (isMobile) {
    return (
      <Button
        variant="contained"
        color="secondary"
        onClick={onClick}
        endIcon={<SvgIcon component={OpenInEditorIcon} inheritViewBox />}
      >
        {t("openInEditor")}
      </Button>
    )
  }

  return (
    <Button
      variant="contained"
      color="secondary"
      target="_blank"
      onClick={onClick}
      href={`${process.env.REACT_APP_WEBAPP_URL}/editor/${assignmentId}`}
      endIcon={<SvgIcon component={OpenInEditorIcon} inheritViewBox />}
    >
      {t("openInEditor")}
    </Button>
  )
}

export default OpenInEditorButton
